import { USER_CONFIG } from '@porterin/booking-flow/src/auth/domain/config/user';
import { z as zod } from 'zod';

export const makeLoginFormSchema = (mobile_regex: RegExp) =>
  zod.object({
    phone: zod
      .string()
      .min(1, USER_CONFIG.EMPTY_MOBILE)
      .regex(mobile_regex, USER_CONFIG.INVALID_MOBILE),
  });

const schema = makeLoginFormSchema(USER_CONFIG.PHONE_REGEX);

export type LoginFormValues = zod.infer<typeof schema>;
